import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// /locale/lang/en
import locale from 'element-ui/lib/locale/lang/en'
// import chinesejian from 'element-ui/lib/locale/lang/zh-CN'

//引入多语言注册文件
// import i18n from '@/i18n/index';

import dragVerify from 'vue-drag-verify2'

import App from './App.vue'
// import 'default-passive-events'

import router from './router'
import store from './store'
import './styles/index.less'
import './assets/iconFont/iconfont.css'
import './assets/shezhi/iconfont.css'

import language from './utils/language' // 1.先引入
Vue.prototype.$language = language // 2.全局注册

// console.log('打印仓库语言',store.state.languageType)

Vue.config.productionTip = false

// / Vue.prototype.$store.Language == 0 ?locale:chinesejian
// Vue.use(ElementUI, {
//   locale:store.state.languageType == 0 ?locale:null
// });
Vue.use(ElementUI, {
  locale: locale
})
Vue.use(dragVerify)

//引入自定义右键菜单
import VueContextMenu from 'vue-contextmenu'
Vue.use(VueContextMenu)

//cookies存储
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

// i18n,//引入i18n
//
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// import commonApi from './store/commonApi'
// Vue.prototype.commonApi = commonApi;

// 全局loading
Vue.prototype.openLoading = function () {
  const loading = this.$loading({
    // 声明一个loading对象
    lock: true, // 是否锁屏
    text: 'loading...', // 加载动画的文字
    spinner: 'el-icon-loading', // 引入的loading图标
    // background: 'rgba(0, 0, 0, 0.8)',       // 背景颜色
    // target: '.el-table, .table-flex, .region',       // **需要遮罩的区域，这里写要添加loading的选择器**
    target: ' .region', // **需要遮罩的区域，这里写要添加loading的选择器**
    // fullscreen: true,
    customClass: 'loadingclass' // **遮罩层新增类名，如果需要修改loading的样式**
  })
  setTimeout(function () {
    // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
    loading.close() // 关闭遮罩层
  }, 2000)
  return loading
}

// 禁用右键
// document.oncontextmenu = new Function("event.returnValue=false");
// 禁用选择
// document.onselectstart = function () { return false; }
